import React, { useEffect, useState } from 'react';
import { db } from './config/firebase';
import { getDocs, collection } from 'firebase/firestore';
import { Col, Container, Row, Button } from 'react-bootstrap';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImages } from '@fortawesome/free-solid-svg-icons';
import './App.css'



export default function Gal() {
  const [galleryCollection, setGalleryCollection] = useState([]);
  const galleryCollectionRef = collection(db, 'galerija');
  

  const [equipmentCollection, setEquipmentCollection] = useState([]);
  const equipmentCollectionRef = collection(db, 'spravegalerija');

  const [displayGallery, setDisplayGallery] = useState(true);
  const buttonText = displayGallery ? 'Sprave' : 'Sve slike';
  useEffect(() => {
    const getGalleryCollection = async () => {
      try {
        const data = await getDocs(galleryCollectionRef);
        const filteredData = data.docs.map((doc) => ({ ...doc.data() }));
        setGalleryCollection(filteredData);
        console.log(filteredData);
      } catch (err) {
        console.log(err);
      }
    };
    getGalleryCollection();
  }, []);

  useEffect(() => {
    const getEquipmentCollection = async () => {
      try {
        const data = await getDocs(equipmentCollectionRef);
        const filteredData = data.docs.map((doc) => ({ ...doc.data() }));
        setEquipmentCollection(filteredData);
        console.log(filteredData);
      } catch (err) {
        console.log(err);
      }
    };
    getEquipmentCollection();
  }, []);

  const toggleDisplay = () => {
    setDisplayGallery(!displayGallery);
  };


  return (
    <>
      <Container className='mt-5'>
        <Row className='justify-content-center'>
          <Col className='text-center mb-3'>
            <h3>Galerija</h3>
          </Col>
        </Row>
        <Row className='justify-content-center'>
          <Col>
            
            <Splide
            options={ {
              type: 'slide',
              autoWidth: true,
              gap: '1rem',
              rewind: true,
          } }
          aria-label="React Splide" >
              {displayGallery ? (
                galleryCollection.map((photo, k) => (
                  <SplideSlide key={k}>
                  <img
                  className='image-container2'
                    key={k}
                    src={photo.fotka}
                    alt={`Fotka ${k}`}
                  />
                  </SplideSlide>
                ))
              ) : (
                equipmentCollection.map((photo1, k) => (
                  <SplideSlide key={k}>
                  <img
                  className='image-container2'
                    key={k}
                    src={photo1.fotka}
                    alt={`Fotka ${k}`}
                  />
                  </SplideSlide>
                ))
              )}
              </Splide>
          </Col>
        </Row>
        
      </Container>
      <div className='text-center'>
      <Button variant='dark' size='sm' onClick={toggleDisplay} className='mb-3 mt-3'>
      {buttonText}
      <FontAwesomeIcon icon={faImages} style={{color: "#ffffff", marginLeft: '5px'}} />
      </Button>
      </div>
    </>
  );
}
